import React from 'react';
import { Icon } from './Icon.js';
export const IconVShapedArrowDownFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M11.1954 5.35355C11.5286 5.10776 11.5993 4.63805 11.3536 4.30472C11.1078 3.9716 10.6381 3.9009 10.3048 4.14652L6.00012 7.31839L1.69544 4.14652C1.3621 3.9009 0.8924 3.9716 0.646608 4.30472C0.400996 4.63805 0.471689 5.10776 0.804811 5.35355L5.55481 8.85355C5.81938 9.04849 6.18087 9.04849 6.44544 8.85355L11.1954 5.35355Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconVShapedArrowDownFill12.js.map